import React, { useEffect, useState } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import GridContainer from 'components/Grid/GridContainer';
import { DataGrid, esES } from '@material-ui/data-grid';
// import { DataGrid, esES } from '@mui/x-data-grid';
import GridItem from 'components/Grid/GridItem';
import { wsGetAll } from 'services/WService';

const columns = [
  { field: 'AcctCode', headerName: 'Cuenta', width: 120 },
  { field: 'AcctName', headerName: 'Descripción', width: 500 },
  {
    field: 'SumApplied',
    headerName: 'Monto',
    width: 200,
    editable: true,
    type: 'number',
    sortable: false,
  },
];

const columnsImport = [
  { field: 'AcctCode', headerName: 'Cuenta', width: 120 },
  { field: 'AcctName', headerName: 'Descripción', width: 300 },
  {
    field: 'CashSum',
    headerName: 'Monto',
    width: 100,
    editable: true,
    type: 'number',
    sortable: false,
  },
  { field: 'CardName', headerName: 'En favor de', width: 300 },
  { field: 'Address', headerName: 'Pagar a', width: 300 },
  { field: 'base_zone_description', headerName: 'Zona', width: 120 },
  { field: 'DocDate', headerName: 'Fecha Contable', width: 190 },
  { field: 'Comments', headerName: 'Comentario', width: 300 },
];

function PaymentAccounts(props) {
  const { setTotalAmount } = props;
  const { setAccounts, paymentType } = props;
  const { importDocumentData } = props;

  const { selectionModel, setSelectionModel } = props;
  const { aviableAccounts, setAviableAccounts } = props;

  async function listAccounts(signal = undefined) {
    let entity = 'pymt/received-payment/accounts';
    if (paymentType === 'ACCOMPLISHED') {
      entity = 'pymt/account-sap';
    }

    let res = await wsGetAll(entity, { signal });
    if (signal.aborted) return;
    if (res.success) {
      setAviableAccounts(res.data.map((item) => ({ ...item, SumApplied: 0 })));
    }
  }

  /**
   * !! Dependiendo si el usuario usa enter o click, el evento trae diferentes valores
   */
  function editCell(params) {
    const { id, value } = params;

    if (value < 0) return;

    const accountIndex = aviableAccounts.findIndex((item) => item.AcctCode === id);
    if (accountIndex === -1) return;

    const newAccounts = [...aviableAccounts];
    newAccounts[accountIndex].SumApplied = Number(value);
    setAviableAccounts(newAccounts);
  }

  useEffect(() => {
    let controller = new AbortController();

    if (importDocumentData && importDocumentData.length > 0) {
      const mapped = importDocumentData.map((item) => ({
        AcctCode: item.AcctCode,
        AcctName: item.AcctName || '',
        CardName: item.CardName || '',
        Address: item.Address || 0,
        base_zone_id: item.base_zone_id || '',
        base_zone_description: item.base_zone_description || '',
        CashSum: item.CashSum || '',
        DocDate: item.DocDate || '',
        CFWName: item.CFWName || '',
        Comments: item.Comments || '',
      }));
      setAviableAccounts(mapped);
    } else {
      listAccounts(controller.signal);
    }

    return () => {
      controller.abort();
      setSelectionModel([]);
      setAviableAccounts(undefined);
      setAccounts([]);
      setTotalAmount(0);
    };
  }, [importDocumentData, paymentType]);

  // Recalcular el total
  useEffect(() => {
    if (selectionModel.length === 0) {
      setTotalAmount(0);
      setAccounts([]);
      return;
    }

    let selectedAccounts = aviableAccounts.filter((account) =>
      selectionModel.includes(account.AcctCode),
    );
    let newTotalAmount = selectedAccounts.reduce((prev, account) => prev + account.SumApplied, 0);
    setTotalAmount(newTotalAmount);
    setAccounts(
      selectedAccounts.map((account) => ({
        AcctCode: account.AcctCode,
        SumApplied: account.SumApplied,
      })),
    );
  }, [selectionModel, aviableAccounts]);

  let columnUse = ''; 
  if(!importDocumentData){
    columnUse = columns
  } else{
    columnUse = columnsImport
  }

  return (
    <CardContainer icon={null}>
      <GridContainer>
        <GridItem xs={12} style={{ height: '500px' }}>
          <DataGrid
            key={aviableAccounts}
            localeText={esES.props.MuiDataGrid.localeText}
            columns={columnUse}
            selectionModel={selectionModel}
            onSelectionModelChange={setSelectionModel}
            isCellEditable={(item) => selectionModel.includes(item.id)}
            getRowId={(row) =>
              importDocumentData && importDocumentData.length > 0 ? `${row.AcctCode}-${row.CardName}-${row.Address}` : row.AcctCode
            }

            rows={aviableAccounts || []}
            loading={aviableAccounts === undefined}
            checkboxSelection
            disableSelectionOnClick
            disableColumnFilter
            disableColumnMenu
            disableColumnReorder
            onCellEditCommit={editCell}
          />
        </GridItem>
      </GridContainer>
    </CardContainer>
  );
}

export default PaymentAccounts;
